<template>
  <section class="_ptxs _pbxs">
    <async-loader v-if='memberTransactionsLoading'/>
    <div v-else container>
      <div row>

        <a class="btn --sm" href="javascript:void(0)" @click="toggleFilters" aria-label="toggle column filters">
          <span v-if="showFilters">
          Hide Column Filters
          </span>
          <span v-else>
          Show Column Filters
          </span>
        </a>
        <app-advanced-table
          class='_ptxs _pb0'
          :headers="$props.headers"
          :items="computedFilteredItems"
          :no-data-text="memberTransactionsErrorMessage"
          :custom-sort="tableSorter"
          :clickable="true"
          @cellClicked="gotoMember"
        >
          <template #headers='{ headers, pagination, changeSort }' >
            <tr tabindex="0">
              <th
                v-for="(header, index) in headers"
                :key="header.text"
                tabindex="0"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              >
                <div @click="changeSort(header.value)">
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </div>

                <app-placeholder-input
                  v-if="showFilters"
                  class="-tiny"
                  :value="getFilterValue(index)"
                  @input="setFilterValue(index, header.value, $event)"
                  valueKey="'filter_' + header.value`"
                  label=""
                  />
              </th>
            </tr>
          </template>
        </app-advanced-table>
      </div>
    </div>
  </section>
</template>

<script>
  import AppPlaceholderInput from '@atoms/PlaceholderInput'
  import AsyncLoader from '@molecules/AsyncLoader'
  import memberManagement from '@mixins/memberManagement'
  import AppAdvancedTable from '@organisms/AdvancedTable'
  import tableSorter from '@mixins/tableSorter'

  export default {
    mixins: [memberManagement, tableSorter],
    components: {
      AppAdvancedTable,
      AsyncLoader,
      AppPlaceholderInput
    },
    props: [ 'headers' ],
    data() {
      return {
        showFilters: false,
        filters: {}
      }
    },
    computed: {
      filterables() {
        return this.memberTransactions
      },
      computedFilteredItems() {
        if (!this.showFilters) {
          return this.filterables
        }

        let filteredItems = [ ...this.filterables ]

        Object.keys(this.filters).forEach((index) => {
          const filter = this.filters[index]
          filteredItems = filteredItems.filter(item => {
            if (typeof filter.headerValue !== 'function' && item[filter.headerValue] === undefined) {
              console.warn(`filter ${filter.headerValue} is not found on filterables`)
              return true
            }

            const value = typeof filter.headerValue === 'function' ? filter.headerValue(item) : item[filter.headerValue]

            if (value == null) {
              return false
            }

            return value.toLowerCase().includes(filter.strValue.toLowerCase())
          })
        })

        return filteredItems
      }
    },
    methods: {
      getFilterValue(index) {
        if (!this.filters[index]) {
          return ''
        }

        return this.filters[index].strValue
      },
      setFilterValue(index, headerValue, strValue) {
        this.$set(this.filters, index, { headerValue: headerValue, strValue: strValue })
      },
      toggleFilters() {
        this.showFilters = !this.showFilters

        if (!this.showFilters) {
          Object.keys(this.filters).forEach(filterKey => {
            this.filters[filterKey].strValue = ''
          })
        }
      },
      gotoMember(member) {
        this.$router.push({ name: 'member-details', params: { memberCk: member.memberCk } })
      }
    }
  }
</script>
